import { render } from "./AddPortARisqueModal.vue?vue&type=template&id=8b6b0a34&ts=true"
import script from "./AddPortARisqueModal.vue?vue&type=script&lang=ts"
export * from "./AddPortARisqueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__